import SafeIcon from '../common/SafeIcon';
import AudioPlayer from './AudioPlayer';

const MoneyPageHero = ({ onContactClick }) => (
  <section className="relative overflow-hidden px-4 pb-20 pt-36 sm:px-6 lg:px-8">
    <div className="absolute left-1/2 top-20 h-96 w-96 -translate-x-1/2 rounded-full bg-blue-600/20 blur-[120px]" />
    <div className="relative mx-auto max-w-6xl text-center">
      <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-300">
        <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400" />
        Trusted by 100+ local businesses and service professionals
      </div>
      <h1 className="text-5xl font-extrabold leading-tight tracking-tight text-white md:text-7xl">
        The 24/7 AI Receptionist Built for Small Businesses
      </h1>
      <p className="mx-auto mt-7 max-w-3xl text-lg leading-relaxed text-slate-300 md:text-xl">
        Answer every inbound call instantly, capture leads, qualify prospects, and book calendar
        appointments around the clock without hiring another receptionist.
      </p>
      <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
        <button
          type="button"
          onClick={onContactClick}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-4 text-lg font-bold text-white shadow-[0_0_25px_rgba(37,99,235,0.4)] transition hover:bg-blue-500"
        >
          Start Your Free Trial
          <SafeIcon name="ArrowRight" />
        </button>
        <a href="#demo" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-700 bg-slate-800 px-8 py-4 text-lg font-bold text-white transition hover:bg-slate-700">
          Listen to Live Demo
          <SafeIcon name="Play" />
        </a>
      </div>
      <p className="mt-5 text-sm text-slate-500">No hardware required • 5-minute setup • Cancel anytime</p>
      <div id="demo" className="mx-auto mt-12 max-w-2xl">
        <AudioPlayer />
      </div>
    </div>
  </section>
);

export default MoneyPageHero;